module.exports = __webpack_public_path__ + "static/media/laura-ivasco.8e4c3ab7.png";